import { type FC, useState } from "react";
import { ContextMenu } from "@packsize/components";

import { type ClosingScanFailed } from "@/schemas/routing/closing-carton";

import { SeeDetailsMenuItem } from "../action-menu/see-details-menu-item";
import { ManuallyCloseMenuItem } from "../action-menu/manually-close-menu-item";
import { RemoveClosingMenuItem } from "../action-menu/remove-closing-menu-item";
import { RemoveClosingModal } from "../action-menu/remove-closing-modal";
import { RecloseMenuItem } from "../action-menu/reclose-menu-item";

interface ScanRejectedActionMenuProps {
	readonly scan: ClosingScanFailed;
}

export const ScanRejectedActionMenu: FC<ScanRejectedActionMenuProps> = ({ scan }) => {
	const { closingId, internalUniqueId, alias, failureReason } = scan;
	const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

	return (
		<>
			{(failureReason === "NoProductionOptionsForMachine" || failureReason === "ClosingRemoved") && (
				<>
					<ContextMenu
						popoverProps={{
							anchorOrigin: {
								vertical: "bottom",
								horizontal: "center",
							},
							transformOrigin: {
								vertical: "top",
								horizontal: "right",
							},
						}}
					>
						{failureReason === "NoProductionOptionsForMachine" && internalUniqueId !== null && closingId !== null && (
							<ManuallyCloseMenuItem internalUniqueId={internalUniqueId} closingId={closingId} />
						)}
						{failureReason === "NoProductionOptionsForMachine" &&
							internalUniqueId !== null &&
							closingId !== null &&
							alias !== null && <RemoveClosingMenuItem setIsOpen={setIsRemoveModalOpen} />}
						{internalUniqueId !== null && <SeeDetailsMenuItem internalUniqueId={internalUniqueId} />}
						{failureReason === "ClosingRemoved" && internalUniqueId !== null && (
							<RecloseMenuItem internalUniqueId={internalUniqueId} />
						)}
					</ContextMenu>
					{internalUniqueId !== null && closingId !== null && alias !== null && (
						<RemoveClosingModal
							internalUniqueId={internalUniqueId}
							closingId={closingId}
							alias={alias}
							setIsOpen={setIsRemoveModalOpen}
							isOpen={isRemoveModalOpen}
						/>
					)}
				</>
			)}
		</>
	);
};
